import { PermissionT } from "../types";

export const canCreateProject = (permissions: PermissionT[]): boolean => {
  const p = permissions.find((permission) => permission.name === "create_project");
  return !!p;
};

export default canCreateProject;
